module.exports = __webpack_public_path__ + "img/123.found.6d763f59.svg";